export default function SectionBox(props: any) {
  return (
    <div className="text-center w-full mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8 z-20">
        {props.children}
    </div>
  );
}
